import * as proto from 'src/proto/compiled-protos';
import { Observable, map, of } from "rxjs";
import { IndeterminatePaginatorData } from "src/app/general/components/indeterminate-paginator/indeterminate-paginator-model";
import { OrdersModel } from "./orders-model";
import { BackendService } from "../../services/backend.service";
import { DataTableColumn, StringColumn } from "src/app/general/components/data-table/data-table-column";
import { Util } from "src/app/general/util/util";

export class PaidOrdersByEmailModel implements OrdersModel {
  email: string;
  backendService: BackendService;

  constructor(email: string, backendService: BackendService) {
    this.email = email;
    this.backendService = backendService;
  }

  fetchData(continuationToken: string | null | undefined): Observable<IndeterminatePaginatorData<proto.waiternow.common.IOrderProto>> {
    if (!this.email) {
      return of({data: new Array(), continuationToken: ''});
    }
    return this.backendService.findPaidOrdersByEmailReturnObservable(this.email, continuationToken)
      .pipe(
        map(orders => {
          const paginatorData: IndeterminatePaginatorData<proto.waiternow.common.IOrderProto> = {data: [], continuationToken: continuationToken};
          if (orders) {
            paginatorData.data = orders.orders;
            paginatorData.continuationToken = orders.continuationToken;
          }
          return paginatorData;
        })
      );
  }

  getAdditionalColumns(): Array<DataTableColumn<proto.waiternow.common.IOrderProto>> {
    return [
      new StringColumn(
        /* name= */ 'businessName',
        /* translateId= */ 'business_name',
        /* valueExtractor= */ order => Util.safeString(order.redundantData?.businessName),
        /* hideInCompactMode= */ true
      ),
      new StringColumn(
        /* name= */ 'locationName',
        /* translateId= */ 'location_name',
        /* valueExtractor= */ order => Util.safeString(order.redundantData?.locationName),
        /* hideInCompactMode= */ true
      )
    ];
  }
}
